const locale = {
    lang: {
        tonow: "tonowhehe"
    }
};
export default locale;
